import { render, staticRenderFns } from "./InformalTestsVitrina.vue?vue&type=template&id=200e11c3&scoped=true"
import script from "./InformalTestsVitrina.vue?vue&type=script&lang=js"
export * from "./InformalTestsVitrina.vue?vue&type=script&lang=js"
import style0 from "./InformalTestsVitrina.vue?vue&type=style&index=0&id=200e11c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200e11c3",
  null
  
)

export default component.exports